'use client';

import Link from 'next/link';

export default function AGBPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0f1e', color: '#e2e8f0', fontFamily: "'Inter', sans-serif" }}>
      {/* Header */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontWeight: 800, fontSize: 22, color: '#fff' }}>
              Done<span style={{ color: '#F26522' }}>2</span>Go
            </span>
          </Link>
          <Link href="/" style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px 80px' }}>
        <h1 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 36, fontWeight: 800, color: '#fff', marginBottom: 8 }}>Allgemeine Geschäftsbedingungen</h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', marginBottom: 48 }}>Stand: Juni 2026</p>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 1 Geltungsbereich</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen Done2Go (nachfolgend „Anbieter") und dem Kunden (nachfolgend „Auftraggeber") über die Erbringung von Webdesign-, Digitalisierungs- und KI-Dienstleistungen. Abweichende Bedingungen des Auftraggebers werden nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 2 Leistungsumfang</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Der Anbieter erbringt Dienstleistungen im Bereich der digitalen Präsenz für Mikro-Unternehmen, insbesondere:
          </p>
          <ul style={{ lineHeight: 2, color: 'rgba(255,255,255,0.75)', paddingLeft: 24, marginTop: 12 }}>
            <li>Erstellung und Pflege von Websites (Stufe 01 – Stufe 03)</li>
            <li>KI-gestützte Kundenassistenz und Automatisierung</li>
            <li>Data Science und KPI-Lösungen (Power BI, Web-Dashboards)</li>
            <li>Hosting und technische Betreuung</li>
          </ul>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)', marginTop: 16 }}>
            Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Angebot bzw. der Auftragsbestätigung.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 3 Vertragsschluss und Preise</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Ein Vertrag kommt durch die schriftliche Auftragsbestätigung des Anbieters oder durch Beginn der Leistungserbringung zustande. Alle Preise verstehen sich als Nettopreise zuzüglich der gesetzlichen Umsatzsteuer. Einmalige Einrichtungsgebühren sind bei Auftragserteilung fällig. Monatliche Gebühren werden jeweils zum Monatsbeginn in Rechnung gestellt.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 4 Zahlungsbedingungen</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zahlbar. Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz zu berechnen. Der Anbieter behält sich vor, bei Zahlungsverzug die Leistungen bis zur vollständigen Zahlung auszusetzen.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 5 Mitwirkungspflichten des Auftraggebers</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Der Auftraggeber ist verpflichtet, dem Anbieter alle für die Leistungserbringung erforderlichen Informationen, Materialien und Zugänge rechtzeitig zur Verfügung zu stellen. Verzögerungen, die auf fehlende Mitwirkung des Auftraggebers zurückzuführen sind, gehen nicht zu Lasten des Anbieters.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 6 Urheberrecht und Nutzungsrechte</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Alle vom Anbieter erstellten Werke (Designs, Texte, Code, Grafiken) sind urheberrechtlich geschützt. Mit vollständiger Bezahlung erhält der Auftraggeber ein einfaches, nicht übertragbares Nutzungsrecht für den vereinbarten Zweck. Eine Weiterveräußerung oder Weiterlizenzierung bedarf der ausdrücklichen schriftlichen Zustimmung des Anbieters.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 7 Haftungsbeschränkung</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für vorsätzliche oder grob fahrlässige Pflichtverletzungen. Im Übrigen ist die Haftung auf den vorhersehbaren, vertragstypischen Schaden begrenzt. Eine Haftung für mittelbare Schäden, entgangenen Gewinn oder Datenverlust ist ausgeschlossen, soweit gesetzlich zulässig.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 8 Kündigung</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Laufende Hosting- und Wartungsverträge können mit einer Frist von 30 Tagen zum Monatsende gekündigt werden. Einmalige Projektleistungen können nach Auftragserteilung nicht mehr storniert werden; bereits erbrachte Leistungen sind in jedem Fall zu vergüten. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>§ 9 Anwendbares Recht und Gerichtsstand</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist, soweit gesetzlich zulässig, der Sitz des Anbieters.
          </p>
        </section>

        {/* Footer links */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 32, marginTop: 48, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          <Link href="/impressum" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Impressum</Link>
          <Link href="/datenschutz" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Datenschutz</Link>
          <Link href="/agb" style={{ fontSize: 13, color: '#F26522', textDecoration: 'none' }}>AGB</Link>
        </div>
      </div>
    </div>
  );
}
